/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {GenericOverlayComponent} from './generic-overlay.component';
import {LoadingSpinnerModule} from '../loading/loading-spinner/loading-spinner.module';

@NgModule({
    declarations: [GenericOverlayComponent],
    exports: [
        GenericOverlayComponent
    ],
    imports: [
        CommonModule,
        LoadingSpinnerModule
    ]
})
export class GenericOverlayModule {
}
